<template>
  <CancellationLayout>
    <CancellationSectionOverview
      v-if="step === stepEnum.OVERVIEW"
      @confirm-cancellation="goToFeedbackSection"
    />

    <CancellationSectionFeedback
      @confirm-cancellation="receivedCancellationFeedback"
      v-if="step === stepEnum.FEEDBACK"
    />

    <CancellationRefundWarning
      v-if="step === stepEnum.REFUNDABLE"
    />
  </CancellationLayout>
</template>

<script>
import { ref } from '@vue/composition-api'
import CancellationLayout from '@/components/cancellation/CancellationLayout'
import CancellationSectionOverview from '@/components/cancellation/CancellationSectionOverview'
import CancellationSectionFeedback from '@/components/cancellation/CancellationSectionFeedback'
import CancellationRefundWarning from '@/components/cancellation/CancellationRefundWarning'
import useCancellation from '@/components/cancellation/cancellation'
import { requestSubscriptionCancellation } from '../../../api/subscription.api'
import store from '@/store'

export default {
  components: {
    CancellationLayout,
    CancellationSectionOverview,
    CancellationSectionFeedback,
    CancellationRefundWarning
  },
  setup() {
    const stepEnum = {
        OVERVIEW: 'overview',
        FEEDBACK: 'feedback',
        REFUNDABLE: 'refundable',
    }
    const step = ref(stepEnum.OVERVIEW)
    const { trackCancellationFeedbackOnAnlytics } = useCancellation()

    function goToFeedbackSection () {
      step.value = stepEnum.FEEDBACK
    }

    async function receivedCancellationFeedback(cancellationFeedback) {
      store.commit('app/setLoading', true)

      const { feedback, reasons } = cancellationFeedback

      try {
        const response = await requestSubscriptionCancellation(feedback, reasons)

        await trackCancellationFeedbackOnAnlytics(cancellationFeedback)

        if (response.is_refundable) {
          store.commit('app/setLoading', false)
          step.value = stepEnum.REFUNDABLE
        } else {
          window.location.href = '/meu-perfil/plano'
        }
      } catch (err) {
        alert(err.data.error)

        store.commit('app/setLoading', false)
      }

    }

    return {
      step,
      stepEnum,
      goToFeedbackSection,
      receivedCancellationFeedback
    }
  }
}
</script>

<style lang="scss" module>
  @import "~@/components/cancellation/cancellation.scss";
</style>